import { Icon, Text } from '@ui-component-library';

type ToolsTabProps = {
    RunSectionTools: (toolName: string) => void;
};

export function ToolsTab({
    RunSectionTools,
}: ToolsTabProps) {


    return (
        <div className="flex flex-wrap w-full p-6">
            <div className="flex flex-wrap w-full rounded-lg-alt gap-2">
                <Text variant="text-sm/leading-normal/medium" className="py-2 px-4">Verktyg</Text>
                <div className="w-full py-2 px-6 flex flex-row items-center justify-between border border-solid border-[#E6E6E6] rounded-lg-alt gap-2 cursor-pointer" onClick={() => RunSectionTools('edit')}>
                    <div className="flex flex-col gap-0-5">
                        <Text variant="text-sm/leading-normal/medium">Redigera gränser</Text>
                        <Text variant="text-xs/leading-normal/normal">Justera denna avdelningens gränser</Text>
                    </div>
                    <Icon name="ChevronDownSimple" size="large" className="-rotate-90" />
                </div>
                <div className="w-full py-2 px-6 flex flex-row items-center justify-between border border-solid border-[#E6E6E6] rounded-lg-alt gap-2 cursor-pointer" onClick={() => RunSectionTools('delete')}>
                    <div className="flex flex-col gap-0-5">
                        <Text variant="text-sm/leading-normal/medium">Radera avdelning</Text>
                        <Text variant="text-xs/leading-normal/normal">Ta bort denna avdelning permanent</Text>
                    </div>
                    <Icon name="ChevronDownSimple" size="large" className="-rotate-90" />
                </div>
                <div className="w-full py-2 px-6 flex flex-row items-center justify-between border border-solid border-[#E6E6E6] rounded-lg-alt gap-2 cursor-pointer" onClick={() => { RunSectionTools("remove_holes"); }}>
                    <div className="flex flex-col gap-0-5">
                        <Text variant="text-sm/leading-normal/medium">Ta bort hål</Text>
                        <Text variant="text-xs/leading-normal/normal">Tar bort eventuella hål inom avdelningens gränser</Text>
                    </div>
                    <Icon name="ChevronDownSimple" size="large" className="-rotate-90" />
                </div>
                <div className="w-full py-2 px-6 flex flex-row items-center justify-between border border-solid border-[#E6E6E6] rounded-lg-alt gap-2 cursor-pointer" onClick={() => { RunSectionTools("remove_stacked_points"); }}>
                    <div className="flex flex-col gap-0-5">
                        <Text variant="text-sm/leading-normal/medium">Ta bort punktkluster</Text>
                        <Text variant="text-xs/leading-normal/normal">Städar bort punkter staplade på varandra</Text>
                    </div>
                    <Icon name="ChevronDownSimple" size="large" className="-rotate-90" />
                </div>
                <div className="w-full py-2 px-6 flex flex-row items-center justify-between border border-solid border-[#E6E6E6] rounded-lg-alt gap-2 cursor-pointer" onClick={() => { RunSectionTools("simplify"); }}>
                    <div className="flex flex-col gap-0-5">
                        <Text variant="text-sm/leading-normal/medium">Förenkla form</Text>
                        <Text variant="text-xs/leading-normal/normal">Förenklar avdelningsgränsen</Text>
                    </div>
                    <Icon name="ChevronDownSimple" size="large" className="-rotate-90" />
                </div>
            </div>
        </div>
    );
}
